<template>
  <div>
      <h2>
          {{field.label}}
          </h2>
      <ul>
         <li v-for="(item, idx) in items" :key="idx">            
            <md-button class="md-icon-button md-body-1 remove" :md-ripple="false" aria-label="remove item" v-on:click="deleteItem(idx)">
                <md-icon>remove_circle</md-icon></md-button>
                <span class="align-span"><input :value="item" /></span><div class="clear"></div>
        </li>
    <li>
    <input class="new-item" v-model="newItem" v-on:keyup.enter="addItem" />
    </li>
    </ul>
</div>
</template>

<script>
export default {
  props: ['value', 'field'],
  data(){
    return{
    items: Array.isArray(this.value) ? this.value  : [],
    newItem: "",
    }
  },
  methods: {
    addItem: function() { 
        if(!this.items)
        {
            this.items = []
        }
        this.items.push(this.newItem)
        this.newItem = ""
      },
    deleteItem: function(index) 
    {
        this.items.splice(index,1)
    }    

  },
  watch: {
    items: function(newValue) {
        this.$emit('input', newValue)
    },
    value: function(newValue) {
        this.items = newValue
    }
  }
};
</script>

<style scoped>
input {
    width: 100%;
    height: 40px;
    margin-top: 15 px;
}
.new-item {
    padding-left: 52px;
}
.align-span {
    overflow: hidden;
    display: block;
    padding: 0 4px 0 10px
}
.remove {
    float:left;
}
.clear {
        clear: both; 
        }
li {
    margin-top: 5px;
}
ul {
    padding: 0;
    margin: none;
    list-style-type: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TextArray.vue